import "./lib/zod-config";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "./router";
import { registerServiceWorker } from "./lib/push";
import { initTheme } from "./lib/theme";
import "./styles.css";

initTheme();

const container = document.getElementById("root");
if (!container) throw new Error("#root introuvable");

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);

// Notification clicks ask the open app to navigate (in-app paths only, validated in registerServiceWorker).
registerServiceWorker((path) => {
  void router.navigate({ href: path });
});
